(function() {
  'use strict';

  var STATE_TO_PROVINCE = {
    'ANDAMAN AND NICOBAR ISLANDS': 'AN',
    'ANDHRA PRADESH': 'AP',
    'ARUNACHAL PRADESH': 'AR',
    'ASSAM': 'AS',
    'BIHAR': 'BR',
    'CHANDIGARH': 'CH',
    'CHHATTISGARH': 'CG',
    'DADRA AND NAGAR HAVELI AND DAMAN AND DIU': 'DD',
    'DADRA & NAGAR HAVELI': 'DN',
    'DAMAN & DIU': 'DD',
    'DELHI': 'DL',
    'GOA': 'GA',
    'GUJARAT': 'GJ',
    'HARYANA': 'HR',
    'HIMACHAL PRADESH': 'HP',
    'JAMMU AND KASHMIR': 'JK',
    'JHARKHAND': 'JH',
    'KARNATAKA': 'KA',
    'KERALA': 'KL',
    'LADAKH': 'LA',
    'LAKSHADWEEP': 'LD',
    'MADHYA PRADESH': 'MP',
    'MAHARASHTRA': 'MH',
    'MANIPUR': 'MN',
    'MEGHALAYA': 'ML',
    'MIZORAM': 'MZ',
    'NAGALAND': 'NL',
    'ODISHA': 'OR',
    'ORISSA': 'OR',
    'PUDUCHERRY': 'PY',
    'PONDICHERRY': 'PY',
    'PUNJAB': 'PB',
    'RAJASTHAN': 'RJ',
    'SIKKIM': 'SK',
    'TAMIL NADU': 'TN',
    'TELANGANA': 'TS',
    'TRIPURA': 'TR',
    'UTTAR PRADESH': 'UP',
    'UTTARAKHAND': 'UK',
    'UTTARANCHAL': 'UK',
    'WEST BENGAL': 'WB'
  };

  var PROVINCE_TO_STATE = {
    'AN': 'Andaman and Nicobar Islands',
    'AP': 'Andhra Pradesh',
    'AR': 'Arunachal Pradesh',
    'AS': 'Assam',
    'BR': 'Bihar',
    'CH': 'Chandigarh',
    'CG': 'Chhattisgarh',
    'DD': 'Daman and Diu',
    'DN': 'Dadra and Nagar Haveli',
    'DL': 'Delhi',
    'GA': 'Goa',
    'GJ': 'Gujarat',
    'HR': 'Haryana',
    'HP': 'Himachal Pradesh',
    'JK': 'Jammu and Kashmir',
    'JH': 'Jharkhand',
    'KA': 'Karnataka',
    'KL': 'Kerala',
    'LA': 'Ladakh',
    'LD': 'Lakshadweep',
    'MP': 'Madhya Pradesh',
    'MH': 'Maharashtra',
    'MN': 'Manipur',
    'ML': 'Meghalaya',
    'MZ': 'Mizoram',
    'NL': 'Nagaland',
    'OR': 'Odisha',
    'PY': 'Puducherry',
    'PB': 'Punjab',
    'RJ': 'Rajasthan',
    'SK': 'Sikkim',
    'TN': 'Tamil Nadu',
    'TS': 'Telangana',
    'TR': 'Tripura',
    'UP': 'Uttar Pradesh',
    'UK': 'Uttarakhand',
    'WB': 'West Bengal'
  };

  var cache = {};

  // Offline PIN range lookup for instant state identification
  function getProvinceFromPinRange(pinNum) {
    if (pinNum >= 110000 && pinNum <= 110099) return 'DL';
    if (pinNum >= 120000 && pinNum <= 139999) return 'HR';
    if (pinNum >= 140000 && pinNum <= 169999) return 'PB';
    if (pinNum >= 170000 && pinNum <= 179999) return 'HP';
    if (pinNum >= 180000 && pinNum <= 199999) return 'JK';
    if (pinNum >= 200000 && pinNum <= 289999) return 'UP';
    if (pinNum >= 300000 && pinNum <= 349999) return 'RJ';
    if (pinNum >= 360000 && pinNum <= 399999) return 'GJ';
    if (pinNum >= 400000 && pinNum <= 449999) return 'MH';
    if (pinNum >= 450000 && pinNum <= 489999) return 'MP';
    if (pinNum >= 490000 && pinNum <= 499999) return 'CG';
    if (pinNum >= 500000 && pinNum <= 509999) return 'TS';
    if (pinNum >= 510000 && pinNum <= 539999) return 'AP';
    if (pinNum >= 560000 && pinNum <= 599999) return 'KA';
    if (pinNum >= 600000 && pinNum <= 669999) return 'TN';
    if (pinNum >= 670000 && pinNum <= 699999) return 'KL';
    if (pinNum >= 700000 && pinNum <= 749999) return 'WB';
    if (pinNum >= 750000 && pinNum <= 779999) return 'OR';
    if (pinNum >= 780000 && pinNum <= 799999) return 'AS';
    if (pinNum >= 800000 && pinNum <= 859999) return 'BR';
    return '';
  }

  // Identify State & Province Code for PIN code
  function resolveProvinceCode(pincode) {
    var pinNum = parseInt(pincode, 10);
    var fallbackProv = getProvinceFromPinRange(pinNum);
    var fallbackState = PROVINCE_TO_STATE[fallbackProv] || '';

    var url = 'https://api.postalpincode.in/pincode/' + encodeURIComponent(pincode);
    return fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (Array.isArray(data) && data[0] && data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length > 0) {
          var stateName = (data[0].PostOffice[0].State || '').trim();
          var prov = STATE_TO_PROVINCE[stateName.toUpperCase()] || fallbackProv;
          return { province: prov, stateName: stateName || fallbackState };
        }
        return { province: fallbackProv, stateName: fallbackState };
      })
      .catch(function() {
        return { province: fallbackProv, stateName: fallbackState };
      });
  }

  function handleCheck(checkerEl) {
    var input = checkerEl.querySelector('[data-pincode-input]') || document.querySelector('[data-pincode-input]');
    var btn = checkerEl.querySelector('[data-pincode-btn]') || document.querySelector('[data-pincode-btn]');
    var resultEl = checkerEl.querySelector('[data-pincode-result]') || document.querySelector('[data-pincode-result]');
    var rawAllowed = checkerEl.getAttribute('data-deliverable-states') || 'Kerala, Karnataka, Tamil Nadu';
    var allowedStatesList = rawAllowed.split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);

    if (!input || !resultEl) return;

    var pincode = input.value.trim();

    // 1. Validation: 6-digit numeric
    if (!/^\d{6}$/.test(pincode)) {
      displayResult(resultEl, {
        type: 'error',
        text: 'Please enter a valid 6-digit PIN code.'
      });
      return;
    }

    // 2. Cache check
    if (cache[pincode]) {
      displayResult(resultEl, cache[pincode]);
      return;
    }

    // UI Loading state
    btn.disabled = true;
    var originalBtnText = btn.textContent;
    btn.textContent = 'Checking...';
    displayResult(resultEl, {
      type: 'unknown',
      text: 'Verifying delivery availability...'
    });

    // 3. Resolve State and evaluate deliverability against configured active states
    resolveProvinceCode(pincode).then(function(provRes) {
      btn.disabled = false;
      btn.textContent = originalBtnText;

      var stateName = provRes.stateName || '';
      var provinceCode = provRes.province || '';
      var stateLabel = stateName ? ' (' + stateName + ')' : '';

      var isDeliverable = false;

      if (stateName || provinceCode) {
        isDeliverable = allowedStatesList.some(function(allowed) {
          var normState = stateName.toLowerCase();
          var normProv = provinceCode.toLowerCase();
          return allowed === normState || allowed === normProv || normState.indexOf(allowed) !== -1;
        });
      }

      var resObj;
      if (isDeliverable) {
        resObj = {
          type: 'available',
          text: '✓ Delivery is available in your location' + stateLabel + '.'
        };
      } else {
        resObj = {
          type: 'unavailable',
          text: '✕ Sorry, delivery is not available for this PIN code' + stateLabel + '.'
        };
      }

      cache[pincode] = resObj;
      displayResult(resultEl, resObj);
    }).catch(function(err) {
      console.error('[PincodeChecker] Error verifying pincode:', err);
      btn.disabled = false;
      btn.textContent = originalBtnText;
      displayResult(resultEl, {
        type: 'unknown',
        text: 'We could not verify this PIN code. Please check and try again.'
      });
    });
  }

  function displayResult(resultEl, resObj) {
    if (!resultEl) return;
    resultEl.className = 'pincode-result pincode-result--' + resObj.type;
    resultEl.textContent = resObj.text;
    resultEl.style.display = 'block';
    resultEl.style.visibility = 'visible';
    resultEl.style.opacity = '1';
  }

  function initPincodeCheckers() {
    document.querySelectorAll('[data-pincode-checker]').forEach(function(checker) {
      if (checker.dataset.initialized) return;
      checker.dataset.initialized = 'true';

      var input = checker.querySelector('[data-pincode-input]');
      var btn = checker.querySelector('[data-pincode-btn]');

      if (input) {
        input.addEventListener('input', function() {
          this.value = this.value.replace(/\D/g, '').slice(0, 6);
        });

        input.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleCheck(checker);
          }
        });
      }

      if (btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          handleCheck(checker);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPincodeCheckers);
  } else {
    initPincodeCheckers();
  }

  document.addEventListener('shopify:section:load', initPincodeCheckers);
})();
